<template>
  <div
    :class="[
      'HomeContainer',
      { broadcastActive: isBroadcastActive, playActive },
    ]"
  >
    <div class="ViewHome pill-hover">
      <div v-if="enableTv" class="tv-hls">
        <TvHls />
      </div>
      <Marquee :items="page.announcements" :autoplay="true"></Marquee>

      <div class="pills">
        <button
          v-if="isVideoEnabled"
          :class="[
            'button pill solid livevideopill',
            { active: isVideoActive },
          ]"
          @click="onVideoClick"
        >
          <span class="desktop">Live </span>Video
        </button>

        <button
          :class="[
            'button pill solid circle',
            { active: modalActive === 'info' },
          ]"
          @click="modalActive = modalActive === 'info' ? '' : 'info'"
        >
          i
        </button>
      </div>

      <div
        :class="[
          'modal-wrap',
          {
            left: modalActive === 'join-us' && !isVideoEnabled,
          },
        ]"
        v-if="modalActive"
      >
        <div
          v-if="modalActive === 'join-us'"
          class="HomeModal box solid rounded"
        >
          <vue-link
            v-for="item in page.support_summary"
            :to="item.link"
            class="block"
            :key="item.link"
          >
            <h2 class="a-hover underline">{{ item.title }}</h2>
            <br />
            <p v-html="item.text"></p>
          </vue-link>
        </div>
        <div
          v-else-if="modalActive === 'info'"
          class="HomeModal box solid rounded"
        >
          <h3>{{ description }}</h3>
          <hr />
          <h3>Affiliate Stations</h3>
          <div class="flags">
            <a href="http://dublab.de/"
              ><img src="~@/assets/images/flag_de.svg"
            /></a>
            <a href="http://dublab.jp/"
              ><img src="~@/assets/images/flag_jp.svg"
            /></a>
            <a href="http://dublab.es/"
              ><img src="~@/assets/images/flag_es.svg"
            /></a>
            <a href="https://dublab.com.br/"
              ><img src="~@/assets/images/flag_br.svg"
            /></a>
          </div>
          <hr />
          <div v-if="site" class="link-list">
            <div v-for="link in site.social_links" :key="link.url">
              <a :href="link.url" class="underline hover">{{ link.text }}</a>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!isVideoActive"
        class="HomeSlidesContainer"
        @mouseover="showTuneIn"
        @mouseleave="hideTuneIn"
      >
        <HomeSlides :entries="slides"></HomeSlides>
      </div>

      <div v-if="playActive" :style="cursorPosition" class="tune-in"></div>

      <Stream v-if="page.cams && !isVideoActive" :images="page.cams"></Stream>

      <div v-if="isVideoActive" class="VideoWrap" ref="videoWrap">
        <div class="EmbedWrap">
          <div class="embed">
            <iframe :src="this.videoUrl" allow="autoplay;"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "@/lib/content-state";
import HomeSlides from "@/components/HomeSlides";
import Marquee from "@/components/Marquee";
import Stream from "@/components/Stream";
import VueLink from "@/components/VueLink.js";
import TvHls from "@/components/TvHls.vue";

export default {
  name: "ViewHome",
  components: { Stream, HomeSlides, Marquee, VueLink, TvHls },
  mixins: [mixin],
  data() {
    return {
      playActive: false,
      modalActive: "",
      muted: true,
      cursorPosition: { top: 0, left: 0 },
      frame: {},
      enableTv: !!process.env.VUE_APP_ENABLE_HOME_TV,
    };
  },
  methods: {
    modalToggle(key) {
      this[key] = !this[key];
    },
    showTuneIn() {
      if (this.isStreamPaused) {
        this.playActive = true;
        window.addEventListener("mousemove", this.updateCursor);
        window.addEventListener("mouseup", this.onAudioClick);
      }
    },
    hideTuneIn() {
      this.playActive = false;
      window.removeEventListener("mousemove", this.updateCursor);
      window.removeEventListener("mouseup", this.onAudioClick);
    },
    onAudioClick() {
      if (this.isBroadcastActive) {
        this.$store.dispatch("closeBroadcast");
      } else if (this.isStreamPaused) {
        this.$store.dispatch("toggleStream");
      }
      this.hideTuneIn();
    },
    updateCursor(e) {
      const offset = 20;
      this.cursorPosition = {
        top: e.clientY + offset + "px",
        left: e.clientX + offset + "px",
      };
    },
    onVideoClick() {
      this.$store.dispatch("toggleVideo");
    },
  },
  computed: {
    description() {
      if (!this.site) return;
      return this.site.description;
    },
    isBroadcastActive() {
      return this.$store.state.audio.broadcast.active;
    },
    isStreamPaused() {
      return this.$store.state.audio.stream.paused;
    },
    isVideoEnabled() {
      return (
        this.site &&
        this.site.livevideo &&
        this.site.livevideo.active &&
        this.site.livevideo.url
      );
    },
    isVideoActive() {
      return this.$store.state.audio.video.active;
    },
    videoUrl() {
      return this.site.livevideo.url;
    },
    slides() {
      return this.page.slides;
    },
  },
};
</script>

<style scoped>
.HomeContainer {
  --mb: 7.9rem;
  flex: 1;
  background: #000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.HomeContainer.playActive {
  cursor: pointer;
}

.ViewHome {
  display: flex;
  flex-direction: column;
  background: #000;
  flex: 1;
  position: relative;
}

@keyframes glowing {
  0% {
    background-color: silver;
    box-shadow: 0 0 5px silver;
  }
  50% {
    background-color: white;
    box-shadow: 0 0 20px white;
  }
  100% {
    background-color: silver;
    box-shadow: 0 0 5px silver;
  }
}

.pills {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 1rem;
  text-align: right;
}

.pills > * {
  position: relative;
  z-index: 4;
  margin: 1rem;
  display: inline-block;
}

/*.pills > *:first-child {
  float: left;
}*/

.livevideopill {
  color: red;
  animation: glowing 1800ms infinite;
}

.VideoWrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.EmbedWrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.embed {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 177.77777778vh; /* 100 * 16 / 9 */
  min-width: 104%; /* should be 100%, but hacked since dublab vimeo has black bars on left/right edges */
  min-height: 56.25vw; /* 100 * 9 / 16 */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (hover: hover) {
  .embed {
    pointer-events: none;
  }
}

.embed >>> iframe {
  border: 0;
  position: absolute;
  top: -60px;
  left: 0;
  width: 100%;
  height: calc(100% + 150px);
}

.marquee-container {
  color: #fff;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
}

.HomeSlidesContainer {
  position: absolute;
  height: 100%;
  width: 100%;
  border: 0;
  z-index: 2;
}

.HomeStreamContainer {
  position: absolute;
  top: 8rem;
  right: 0;
  bottom: 4rem;
  left: 0;
}

.HomeStreamContainer >>> .embed,
.HomeStreamContainer >>> iframe {
  width: 100%;
  height: 100%;
}

.tune-in {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 11rem;
  height: 2rem;
  pointer-events: none;
  background-image: url("~@/assets/images/tune-in.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.modal-wrap {
  position: absolute;
  z-index: 3;
  width: 38rem;
  max-width: 100%;
  top: 7rem;
  right: 0;
  padding-left: 2rem;
  padding-right: 2rem;
}

.modal-wrap.left {
  right: auto;
  left: 0;
}

.HomeModal {
  background: #fff;
  pointer-events: auto;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  max-height: calc(100vh - 20rem);
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.HomeModal::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.HomeModal > * + * {
  margin-top: 1.8rem;
}

.HomeModal .block {
  display: block;
  text-align: center;
}

.HomeModal .block:not(:last-child) {
  padding-bottom: 2rem;
  border-bottom: 1px solid #000;
}

.HomeModal >>> h2 {
  display: inline-block;
  text-align: center;
  margin-bottom: 1rem;
}

.HomeModal >>> figure {
  margin: 0 auto 2rem;
  height: 10rem;
  width: 10rem;
  padding-bottom: 0;
}

.HomeModal >>> p {
  text-align: left;
}

.HomeModal >>> hr {
  height: 1px;
  border: 0;
  background: #000;
}

.HomeModal .link-list {
  padding-bottom: 0.5rem;
}

.HomeModal .link-list > * {
  margin-bottom: 0.15em;
}

.HomeModal p.tac {
  text-align: center;
  padding-bottom: 1rem;
}

.HomeModal .flags {
  width: 100%;
}

.HomeModal .flags > * {
  display: inline-block;
  height: auto;
  width: 5rem;
  height: 3.4rem;
  margin: 0 1rem;
}
/* Make breakpoint for time and make header nav font smaller*/
@media (max-width: 1050px) {
}

@media (max-width: 920px) {
  .HomeContainer {
    padding: 0;
  }

  .HomeContainer.broadcastActive {
    padding: 0;
  }

  .pills {
    padding: 0.75rem;
  }

  .pills > * {
    margin: 0.75rem;
  }

  .modal-wrap {
    top: 7rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .HomeModal {
    max-height: calc(100vh - 28rem);
  }
}

@media (max-width: 560px) {
  .desktop {
    display: none;
  }

  .modal-wrap {
    width: 100%;
  }
}

.tv-hls {
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
</style>
``
